import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/product-type';

export interface ProductTypeFieldsModel {
    id?: string;
    name: string;
    description: string | null;
    renewalSettings?: string | null;
    renewalDaysNumber?: number | null;
    contractTemplate?: string | null;
    consultancyFieldsRequired?: boolean;
    templateConceptClientInvoice?: string | null;
    templateConceptTutorInvoice?: string | null;
    templateConceptInternalInvoice?: string | null;
}

export class ProductTypeService extends RestServiceConnection {

    /**
     * Lista todos los tipos de productos del sistema con filtros opcionales
     * @param filters - Filtros opcionales para la búsqueda
     * @returns Promise con la respuesta del servidor
     */
    listProductTypes = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    listProductTypesForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-product-types-for-select',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * Obtiene un tipo de producto específico por su ID
     * @param id - ID del tipo de producto a obtener
     * @returns Promise con la respuesta del servidor
     */
    getProductTypeById = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { productTypeId: id },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    /**
     * Crea un nuevo tipo de producto
     * @param entity - Datos del tipo de producto a crear
     * @returns Promise con la respuesta del servidor
     */
    createProductType = async (entity: ProductTypeFieldsModel) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: entity,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    /**
     * Edita un tipo de producto existente
     * @param entity - Datos del tipo de producto a editar
     * @returns Promise con la respuesta del servidor
     */
    editProductType = async (entity: ProductTypeFieldsModel) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: entity,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    updateContractWatermark = async (productTypeId: string, contractWatermark?: File | null, removeContractWatermark?: boolean) => {
        const formData = new FormData();
        formData.append('productTypeId', productTypeId);

        if (contractWatermark) {
            formData.append('contractWatermark', contractWatermark);
        }

        if (removeContractWatermark) {
            formData.append('removeContractWatermark', '1');
        }

        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/update-contract-watermark',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }

    /**
     * Elimina un tipo de producto específico
     * @param productTypeId - ID del tipo de producto a eliminar
     * @returns Promise con la respuesta del servidor
     */
    deleteProductType = async (productTypeId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { productTypeId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    /**
     * Elimina múltiples tipos de productos
     * @param productTypeIds - Array de IDs de tipos de productos a eliminar
     * @returns Promise con la respuesta del servidor
     */
    deleteMultipleProductTypes = async (productTypeIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { productTypeIds },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    listInvoiceConceptVariables = async (invoiceType: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-invoice-concept-variables',
            data: { invoiceType },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

}
